angular.module('taric.model.sbt',['common.helper', 'ngResource']).factory('QuerySbt', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/sbt/query', {}, {
        query: {
            method: 'GET',
            isArray: false
        }
    });
}).service('SearchByTextModel', function($q, $translate, CONSTANTS, CommonHelper, QuerySbt){
    var model = this;
    var searchCriteria = null;
    var searchResult = null;
    model.getSearchResult = function (){
        return searchResult;
    };
    model.getSearchCriteria = function (){
        return searchCriteria;
    };
    model.resetSearchCriteria = function(){
        searchCriteria = {};
        searchCriteria.simulationDate = new Date();
        searchCriteria.textSearch = null;
        searchCriteria.goodsNomenclatureDescription = true;
        searchCriteria.additionalCodeDescription = true;
        searchCriteria.footnoteDescription = true;
        searchCriteria.language = CommonHelper.getLanguageCode($translate.use());
        searchCriteria.ascending = true;
    };
    model.resetSearchResult = function(){
        searchResult = null;
    };
    model.reset = function(){
        model.resetSearchCriteria();
        model.resetSearchResult();
    };
    model.reset();
    model.searchText = function(page){
        var deferred = $q.defer();
        var options = {
            simulationDate: CommonHelper.getRestDateString(searchCriteria.simulationDate),
            textSearch: searchCriteria.textSearch,
            additionalCodeDescription: searchCriteria.additionalCodeDescription,
            footnoteDescription: searchCriteria.footnoteDescription,
            goodsNomenclatureDescription: searchCriteria.goodsNomenclatureDescription,
            sortOrder: searchCriteria.ascending? 'A' : 'D',
            sortColumn: searchCriteria.sortCol,
            language: CommonHelper.removeSpaceCharacters(searchCriteria.language)
        };
        
        if (page) {
        	
        	options.offset = CommonHelper.getOffset(page);
        	options.count = CONSTANTS.rowsPerPage;
        }
        
        var result = QuerySbt.query(options, function () {
            var returnedResult = {};
            returnedResult.totalItems = result.count;
            returnedResult.items = result.items;
            returnedResult.currentPage= page;
            if (page){
                searchResult = returnedResult;
            }
            deferred.resolve(returnedResult);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
});


// WEBPACK FOOTER //
// ./app/taric/nomenclature/sbt/text-model.js